import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

export const EarningsSectionCollapseButton = ({
  isCollapsed,
  onToggle,
}: {
  isCollapsed: boolean;
  onToggle: () => void;
}) => {
  /* Render */
  const render = () => (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="h-5 w-5 rounded-full p-0 text-slate-300 hover:bg-slate-100 hover:text-slate-500"
      onClick={onToggle}
    >
      {isCollapsed ? (
        <ChevronDownIcon className="h-3.5 w-3.5" />
      ) : (
        <ChevronUpIcon className="h-3.5 w-3.5" />
      )}
    </Button>
  );

  return render();
};
